/* eslint-disable */
import React, { FC, useEffect, useState } from 'react'
import * as ModalStyles from '../../../../../ModalWindow/modal.styles'
import * as LocalStyles from '../../styles'
import { ModalButton } from '../../../../../unansweredQuestions/styles'
import { TrainButtonState } from '../../../../../unansweredQuestions/util/button'
import { KnowledgeQuestion } from '../trained_questions/knowledge-question'
import { NoSubQuestionProps, TrainedQuestion } from '../types'
import { alertError, alertSuccess } from 'api'
import { userFeedbackService } from '../../../../api/userFeedback'
import { unknownQuestionService } from '../../../../../../api/unknownQuestions'
import TabTile from '../../../../../../../data/components/TabTile'
import { SelectQuestionType } from './buttons/select-question-type'

export const NoSubQuestionView: FC<NoSubQuestionProps> = ({
  trainingQuestions,
  question: incomeQuestion,
  answer: incomeAnswer,
  createNewQuestionCallback,
  feedbackId,
  setSolvedCallback,
  modifyQuestions,
}) => {
  const [question, setQuestion] = useState(incomeQuestion)
  const [answer, setAnswer] = useState(incomeAnswer)
  const [questionType, setQuestionType] = useState<string>(null)
  const [buttonIsActive, setButtonIsActive] = useState<boolean>(false)
  const [expanded, setExpanded] = useState<boolean>(false)
  const [trainedQuestions, setTrainedQuestions] = useState<TrainedQuestion[]>(trainingQuestions)

  useEffect(() => {
    const questionAndAnswerIsNotEmpty = Boolean(question) && Boolean(answer)
    setButtonIsActive((incomeQuestion != question || incomeAnswer != answer) && questionType != null && questionAndAnswerIsNotEmpty)
  }, [question, answer, questionType])

  useEffect(() => {
    modifyQuestions(trainedQuestions)
  }, [trainedQuestions])

  const handleQuestionChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setQuestion(event.target.value)
  }

  const handleAnswerChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setAnswer(event.target.value)
  }

  const handleExpanded = () => {
    setExpanded(!expanded)
  }

  const deleteTrainedQuestion = (id: string) => {
    unknownQuestionService.deleteQuestionById(id).then(() => {
      setTrainedQuestions(prevState => prevState.filter(question => question.trainingQuestionId != id))
    })
  }

  const updateQuestion = async (
    id: string,
    questionBeforeUpdate: string,
    questionForUpdate: string,
    answer: string,
    questionType: string
  ) => {
    try {
      await unknownQuestionService.updateQuestion({ id, questionBeforeUpdate, questionForUpdate, answer, type: questionType }, true)
      await unknownQuestionService.trainQuestion({ id, followUp: false }, false)
      setTrainedQuestions(prev =>
        prev.map(q => (q.trainingQuestionId === id ? { ...q, question: questionForUpdate, answer } : q)),
      )
    } catch {
      alertError('Failed to update question. Please try again.')
    }
  }

  const handleCreationNewQuestion = async () => {
    try {
      const res = await createNewQuestionCallback({ question, answer, type: questionType, train: false })

      if (res && res.id) {
        await userFeedbackService.pushQuestionToTheList(feedbackId, {
          toSubQuestion: false,
          idToPush: res.id,
        })

        alertSuccess('Training Question is added')

        setTrainedQuestions(prevState => [
          ...prevState,
          {
            trainingQuestionId: res.id,
            question,
            answer,
            questionType: questionType
          },
        ])
      }
    } catch (error) {
      alertError('Something went wrong. Please try again.')
    } finally {
      setSolvedCallback(true)
    }
  }

  return (
    <>
      <div style={{ display: 'flex', gap: '16px', width: '100%' }}>
        <ModalStyles.ModalContainerSectionItem style={{ flex: 1 }}>
          <ModalStyles.SubHeader>{'Question'}</ModalStyles.SubHeader>
          <LocalStyles.AnswerInput as="textarea" value={question} onChange={handleQuestionChange} />
        </ModalStyles.ModalContainerSectionItem>

        <ModalStyles.ModalContainerSectionItem style={{ flex: 1 }}>
          <ModalStyles.SubHeader>{'Answer'}</ModalStyles.SubHeader>
          <LocalStyles.AnswerInput as="textarea" value={answer} onChange={handleAnswerChange} />
        </ModalStyles.ModalContainerSectionItem>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 'auto' }}>
        <SelectQuestionType
          questionCallback={value => setQuestionType(value)}
        />
        <ModalButton
          onClick={() => {
            handleCreationNewQuestion()
            setButtonIsActive(false)
          }}
          state={buttonIsActive ? TrainButtonState.ACTIVE : TrainButtonState.INACTIVE}>
          Add New
        </ModalButton>
      </div>
      {trainingQuestions?.length > 0 && (
        <TabTile
          tab={{
            name: <span>{'Trained Questions by Feedback'}</span>,
          }}
          expanded={expanded}
          onChange={handleExpanded}>
          {trainingQuestions.map((q, index) => (
            <div
              key={index}
              style={{
                padding: '16px',
                borderRadius: '8px',
                background: '#f9f9f9',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              }}>
              <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <KnowledgeQuestion
                  question={q.question}
                  answer={q.answer}
                  deleteTrainingQuestionCallback={deleteTrainedQuestion}
                  createQuestionCallback={handleCreationNewQuestion}
                  updateQuestionCallback={updateQuestion}
                  questionType={'trained'}
                  questionId={q.trainingQuestionId}
                  initQuestionType={q.questionType}
                />
              </div>
            </div>
          ))}
        </TabTile>
      )}
    </>
  )
}
